import {createApp} from "vue";
import AppRelationPosts from "./AppRelationPosts.vue";

document.addEventListener("DOMContentLoaded", () => {
  const relationPostsArea = document.getElementById('js-relation-posts');
  if (relationPostsArea) {
    const app = createApp(AppRelationPosts);
    app.provide('categoryId', Number(relationPostsArea.dataset.categoryId));
    app.provide('userId', Number(relationPostsArea.dataset.userId));
    app.provide('postId', relationPostsArea.dataset.postId ? Number(relationPostsArea.dataset.postId) : 0);
    app.mount(relationPostsArea);
  }
});
